import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App.jsx";

// Custom CSS
import "@/assets/scss/app.scss";

// Redux Store
import { store } from './app/store.js';
import { Provider } from 'react-redux';

// Router
import { BrowserRouter } from 'react-router-dom';

// i18n
import "./i18n.js"; // Import i18n configuration

const container = document.getElementById("root");

// Basename = préfixe de montage de l'app. Dans le méga-conteneur GAO, l'app est
// buildée avec base=/jeu-alignement/, donc import.meta.env.BASE_URL vaut
// "/jeu-alignement/" ; en dev/multi-conteneurs c'est "/". Sans basename, toute
// navigation react-router absolue (et AutoLogin) sort à la racine du conteneur
// → 404. On retire le slash final que react-router n'attend pas.
const ROUTER_BASENAME = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);